import * as actionTypes from 'modules/audits/actionTypes';
import { SELECT_SOURCE } from 'modules/audits/constants';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const clearError = () => null;
const hasError = (_, { payload }) => payload.message;

const clearAuditsError = (state, action) => (action.meta?.source === SELECT_SOURCE ? state : null);
const auditsError = (state, action) => (action.meta?.source === SELECT_SOURCE ? state : hasError(state, action));

export default createReducer(initialState, {
  [actionTypes.FETCH_AUDITS_REQUEST]: clearAuditsError,
  [actionTypes.FETCH_AUDIT_REQUEST]: clearError,
  [actionTypes.PUT_REQUEST]: clearError,
  [actionTypes.POST_CLONE_REQUEST]: clearError,
  [actionTypes.PATCH_STATUS_REQUEST]: clearError,
  [actionTypes.DELETE_REQUEST]: clearError,
  [actionTypes.FETCH_AUDITS_FAILURE]: auditsError,
  [actionTypes.FETCH_AUDIT_FAILURE]: hasError,
  [actionTypes.PUT_FAILURE]: hasError,
  [actionTypes.POST_CLONE_FAILURE]: hasError,
  [actionTypes.PATCH_STATUS_FAILURE]: hasError,
  [actionTypes.DELETE_FAILURE]: hasError,
  [actionTypes.POST_FAILURE]: hasError,
});
